import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from '@mui/material';

interface CopyToNextMonthDialogProps {
  open: boolean;
  isCopying: boolean;
  selectedMonth: string;
  nextMonthLabel: string;
  requestCount: number;
  onClose: () => void;
  onConfirm: () => void;
}

const CopyToNextMonthDialog: React.FC<CopyToNextMonthDialogProps> = ({
  open,
  isCopying,
  selectedMonth,
  nextMonthLabel,
  requestCount,
  onClose,
  onConfirm,
}) => (
  <Dialog open={open} onClose={() => !isCopying && onClose()}>
    <DialogTitle>Copy to {nextMonthLabel}</DialogTitle>
    <DialogContent>
      <DialogContentText>
        Copy all {requestCount} Fitpass request
        {requestCount === 1 ? '' : 's'} from {selectedMonth} to {nextMonthLabel}?
        Employee details and additional people will be copied.
      </DialogContentText>
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose} disabled={isCopying}>
        Cancel
      </Button>
      <Button onClick={onConfirm} variant="contained" disabled={isCopying}>
        {isCopying ? 'Copying...' : 'Copy'}
      </Button>
    </DialogActions>
  </Dialog>
);

export default CopyToNextMonthDialog;
